export const MIN_SIZE = 15;
export const MAX_SIZE = 30;

export const MIN_RADIUS = 0;
export const MAX_RADIUS = 32;

export const MIN_ACTION_DURATION = 1000; // value in ms
export const DEFAULT_ACTION_DURATION = 5000; // value in ms

export const DEFAULT_RADIUS = 16; // value in ms

export const CARD_MIDDLE_PADDING_PERCENTAGE = 0.1;
export const CARD_PADDING_PERCENTAGE = 0.05;

export const POSITIONS = {
  TOP_LEFT: { id: 1, type: 'top_left', name: 'call_to_action.editor.positions.top_left' },
  TOP_MIDDLE: { id: 2, type: 'top_middle', name: 'call_to_action.editor.positions.top_middle' },
  TOP_RIGHT: { id: 3, type: 'top_right', name: 'call_to_action.editor.positions.top_right' },
  BOTTOM_LEFT: { id: 4, type: 'bottom_left', name: 'call_to_action.editor.positions.bottom_left' },
  BOTTOM_MIDDLE: { id: 5, type: 'bottom_middle', name: 'call_to_action.editor.positions.bottom_middle' },
  BOTTOM_RIGHT: { id: 6, type: 'bottom_right', name: 'call_to_action.editor.positions.bottom_right' },
  MIDDLE: { id: 7, type: 'middle', name: 'call_to_action.editor.positions.middle' },
  MIDDLE_LEFT: { id: 8, type: 'middle_left', name: 'call_to_action.editor.positions.middle_left' },
  MIDDLE_RIGHT: { id: 9, type: 'middle_right', name: 'call_to_action.editor.positions.middle_right' },
};

export const INITIAL_TEXT_COLORS = ['white', 'black'];

export const INITIAL_BUTTON_BACKGROUND = ['green', 'purple'];

export const INITIAL_ACTION_SETTINGS = {
  text: '',
  url: '',
  size: Math.round(MAX_SIZE / 2),
  radius: MAX_RADIUS / 2,
  position: POSITIONS.TOP_LEFT.type,
};

export const STEP_FROM_ACTION_OFFSET = 150; // value in ms
